import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'
import { getIn, useFormikContext } from 'formik'

type Props = {
  fieldName: string
}

export function useData(props: Props) {
  const { fieldName } = props

  const { errors, touched } = useFormikContext<ILeadFormModel>()

  const errorText: string | undefined =
    touched[fieldName] == true && errors[fieldName]
      ? getIn(errors, fieldName)
      : undefined

  const hasError = !!errorText

  return { errorText, hasError }
}
